'use strict'

export default class SupplierItemProduct {

    constructor (attributes, element, supplierItemId) {
        this.element = element
        this.supplierItemId = supplierItemId
        for (let attributeName in attributes) {
            if (attributes.hasOwnProperty(attributeName)) {
                this[attributeName] = attributes[attributeName]
            }
        }

        this.init()
    }

    get envSiteRoot () {
        return '/var/www/web/sites/66shin.ru'
    }

    get envSiteUrl () {
        return 'https://66shin.ru'
    }

    init () {
        let element = this.element
        if (this.element) {
            this.element.querySelector('[data-product-name]').innerText = this.fullName
            this.element.querySelector('[data-product-name]').href = '#'
            if (this['product_publish'] !== 0) {
                this.element.querySelector('[data-product-name]').href = 'https://66shin.ru/catalog/' + this['product_category_id'] + '/' + this['product_id']
                this.element.querySelector('[data-product-name]').innerText = this.fullName
            }
            const dataImageWrapper = this.element.querySelector('[data-image-wrapper]')

            if (dataImageWrapper) {
                dataImageWrapper.innerHTML = this.imageTemplate
            }

            const dataImageEditor = this.element.querySelector('[data-image-editor]')

            if (dataImageEditor) {
                dataImageEditor.innerHTML = this.imageEditor
            }

            if (this.image) {
                //TODO: Set fadein

                // element.querySelector('img').fadeIn()
            }

        }
    }

    get name () {
        return this['name_ru-RU']
    }

    getUrl () {
        return 'https://66shin.ru/catalog/'
            + this['product_category_id']
            + '/'
            + this['product_id']
    }

    get fullName () {
        return this.name + ' арт: ' + this['product_id'] + ', ' + this.price + '₽ / ' + this.quantity + ' шт.'
    }

    get price () {
        return Math.round(this['product_price'] * 100) / 100
    }

    get quantity () {
        return Math.round(this['product_quantity'] * 100) / 100
    }

    get debug () {
        return true
    }

    get imageTemplate () {
        let result = ''
        if (!this.debug) {
            result = `<a href="${this.image}"
                    data-fancybox="gallery">
                    <img src="http://beta.66shin.ru/api/joomla/jshopping/products/${this.product_id}/image"
                             onerror="this.onerror=null;this.src='/images/search/no-image.png';"
                             data-product-image="${this.supplierItemId}"
                             class="lazy img-fluid"
                             style="max-height: 40px"
                             data-preview
                             ></a>`
        }

        return result

    }

    get imageEditor () {
        let result = ''
        if (!this.debug) {
            result = `
<div class="row no-gutters justify-content-end">
<div class="col-auto">
 <input
                    name="image"
                    style="display: none"
                    data-result-input="${this.supplierItemId}">

                    <div class="custom-file" style="width: 47px">


                    <input
                    class="custom-file-input"
                    data-file-input="${this.supplierItemId}"
                    type="file">

                    <label for="image" class="custom-file-label"></label>
                    </div>
</div>
<div class="col-auto">
    <button class="btn btn-outline-secondary"
                    type="button"
                    data-cropper-init
                    data-file-input="[data-file-input='${this.supplierItemId}']"
                    data-result-input="[data-result-input='${this.supplierItemId}']"
                    data-img="[data-product-image=${this.supplierItemId}]"
                    data-title="${this.fullName}"
                    title="Редактировать изображение"
            >
                <i class="fa fa-edit"></i>
            </button>

</div>
</div>


        `
        }
        return result
    }

}

